"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var selection_1 = require("./selection");
var State = /** @class */ (function () {
    // create everything with initial defaults
    function State() {
        // api call status: cache last url fragment
        this.loading = '';
        // list of flex airports
        this.airports = null;
        // cache for gateway responses per price model
        this.cachedGateways = {};
        this.fetchTime = 0;
        // whether the respective RNF direction is selected (or not selected) by the user
        this.rnfDeparture = false;
        this.rnfArrival = false;
        // selected rail class, i.e. '1', '2'
        this.rnfCategory = '2';
        // response from iris for selected rail to/from gateway
        this.rnfTransportations = [];
        this.rnfTotalPrice = 0;
        // price differ amount for current connection
        this.priceDiffer = 0;
        this.flightSelection = new selection_1.Selection();
        this.flights = [];
        this.selectedFilters = {
            airlineCodes: [],
            airport: null,
            flightClass: null,
            flightDirection: 'RT',
            nonstop: false
        };
        this.steps = {
            flexInfo: true,
            flexSearch: false,
            flexFlights: false,
            flexRNF: false
        };
        this.cachedGateways = {};
    }
    return State;
}());
exports.State = State;
//# sourceMappingURL=state.js.map